import React from 'react';
import Button from 'chameleon/ui-stack/ui/base/button';

const ProgressButton = () => {
  return (
    <Button isPrimary tabIndex={0} accessibility={{ 'aria-label': 'View All' }}>
      View All
    </Button>
  );
};

export default ProgressButton;
